import {
  Inline, FlagSpa, FlagFra, FlagDeu, FlagEng,
  FlagIta, FlagPol, FlagPor, FlagSwe, FlagUsa,
  FlagUkr
} from 'src/viewLayer/components/DesignSystem';

import {
  allAvailableLocales,
  getTranslatedName
} from 'src/dataLayer/localData/displayLanguages';
import { LOCALE } from 'src/dataLayer/env';
import { DisplayLanguageItems, FlagItem } from 'src/types/learnLanguage';

const FlagMap: { [key: string]: { [key: string]: JSX.Element | string} } = {
  de: { Flag: <FlagDeu/>, emoji: '🇩🇪' },
  en: { Flag: <FlagUsa/>, emoji: '🇺🇸' },
  en_GB: { Flag: <FlagEng/>, emoji: '🇬🇧' },
  es: { Flag: <FlagSpa/>, emoji: '🇪🇸' },
  fr: { Flag: <FlagFra/>, emoji: '🇫🇷' },
  it: { Flag: <FlagIta/>, emoji: '🇮🇹' },
  pl: { Flag: <FlagPol/>, emoji: '🇵🇱' },
  pt: { Flag: <FlagPor/>, emoji: '🇵🇹' },
  sv: { Flag: <FlagSwe/>, emoji: '🇸🇪' },
  uk: { Flag: <FlagUkr/>, emoji: '🇺🇦' }
};

const displayLanguageItem = (displayLanguage: string, name: string): FlagItem => {
  const { Flag } = FlagMap[displayLanguage];
  const { emoji } = FlagMap[displayLanguage];

  return {
    desktop: (
      <Inline gap={8} alignItems="center" className={`locale--icon--${displayLanguage}`}>
        {Flag} {name}
      </Inline>
    ),
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    mobile: `${emoji.toString()} ${name}`
  };
};

export const getDisplayLanguageItems = (): DisplayLanguageItems => {
  const unselectedDisplayLanguages = allAvailableLocales
    .filter((n) => n !== LOCALE)
    .map((alpha2) => ({ langCode: alpha2, langName: getTranslatedName(alpha2) }));
  const selectedDisplayLanguage = { langCode: LOCALE, langName: getTranslatedName(LOCALE) };

  const selected = displayLanguageItem(
    selectedDisplayLanguage.langCode,
    selectedDisplayLanguage.langName
  );
  const languageItems = { [selectedDisplayLanguage.langCode]: selected };
  for (const { langName, langCode } of unselectedDisplayLanguages) {
    languageItems[langCode] = displayLanguageItem(langCode, langName);
  }
  return languageItems;
};
